import axios from 'axios';
import * as Config from '../../config';

const state = {
    searchStudy: null
};

const getters = {
    getSearchStudy: (state) => {
        return state.searchStudy;
    }
};

const actions = {
    variable_update({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'variable/update', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    variable_update_by_name({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'variable/update-by-name', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    variable_get({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'variable/get', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    setSearchStudy({ commit }, value) {
        commit('SET_SEARCH_STUDY', value);
    }
}

const mutations = {
    SET_SEARCH_STUDY(state, value) {
        state.searchStudy = value;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};